import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function UserAgreement() {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1 style={styles.title}>User Agreement</h1>
      </div>

      <div style={styles.content}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Service Description</h2>
          <p style={styles.text}>
            This VPN service (hereinafter referred to as "the Service") is provided by an independent developer based in Washington State, USA. Before using the Service, please carefully read and understand all terms of this Agreement.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Service Content</h2>
          <p style={styles.text}>
            The Service provides VPN functionality to help users access internet resources more quickly and securely. Services include but are not limited to:
          </p>
          <ul style={styles.list}>
            <li>Secure network connection</li>
            <li>Traffic usage statistics</li>
            <li>Multi-platform client support</li>
            <li>Technical support services</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. User Obligations</h2>
          <p style={styles.text}>When using the Service, users must comply with the following:</p>
          <ul style={styles.list}>
            <li>Comply with all applicable laws and regulations in your jurisdiction</li>
            <li>Do not use the Service for illegal activities</li>
            <li>Do not transmit illegal or harmful content</li>
            <li>Do not attack or disrupt the service system</li>
            <li>Do not transfer or sell your account to others</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Account Management</h2>
          <p style={styles.text}>
            After registering an account, users are responsible for maintaining the security of their account information. The Service is not liable for account breaches or losses caused by user negligence.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Service Changes and Interruptions</h2>
          <p style={styles.text}>
            The Service reserves the right to modify, suspend, or terminate part or all of the services at any time. We will make reasonable efforts to notify users in advance of service interruptions due to maintenance or upgrades.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Disclaimer</h2>
          <p style={styles.text}>
            The Service only provides VPN technology support and is not responsible for content accessed by users through the Service. Users assume all risks associated with using the Service.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Agreement Modifications</h2>
          <p style={styles.text}>
            The Service reserves the right to modify this Agreement at any time. Modified terms will be posted on the website, and continued use of the Service constitutes acceptance of the modified Agreement.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Contact Information</h2>
          <p style={styles.text}>
            For any questions, please contact us:<br />
            Email: douxingma@zohomail.com<br />
            Location: Washington State, USA
          </p>
        </section>

        <p style={styles.updateTime}>Last Updated: April 23, 2026</p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: '100vh',
    background: '#f5f7fa',
    padding: '20px'
  },
  header: {
    maxWidth: '800px',
    margin: '0 auto 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  },
  backBtn: {
    padding: '10px 20px',
    background: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#666'
  },
  title: {
    margin: 0,
    color: '#333',
    fontSize: '28px',
    fontWeight: 'bold'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    background: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
  },
  section: {
    marginBottom: '32px'
  },
  sectionTitle: {
    color: '#333',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  text: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    margin: '0 0 12px 0'
  },
  list: {
    color: '#666',
    fontSize: '15px',
    lineHeight: '1.8',
    paddingLeft: '24px'
  },
  updateTime: {
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '1px solid #f0f0f0',
    color: '#999',
    fontSize: '14px',
    textAlign: 'center'
  }
};
